<script setup lang="ts">
import {computed} from "vue";

const PARTNERS_URL = window.__APP_CONFIG__.APP_PARTNERS_URL

const displayUrl = computed(() => {
  const url = PARTNERS_URL
  const idx = PARTNERS_URL.indexOf('://')
  return idx !== -1 ? url.slice(idx + 3) : url
})
</script>
<template>
  <div class="space-y-2 prose dark:prose-invert">
    <p>If you are a Bookmaker, Affiliate, Influencer or other interested business then please get in touch via our partner's website.</p>
    <p>
<!--      Email: <a href="mailto:info@betpic.com" class="text-blue-600 dark:text-blue-400 underline">info@betpic.com</a><br>-->
      Website: <a :href="PARTNERS_URL" class="text-blue-600 dark:text-blue-400 underline">{{displayUrl}}</a>
    </p>
  </div>
</template>